// Small, pure geometry helpers for map points ({ lat, lng } in degrees).
// No React, no Google — so components/ui/PinCompareMap and the Order
// Listing's address check share one formula and jest needs no DOM.

/** A usable map point: both coordinates are finite numbers. */
export const isMapPoint = (p) =>
  !!p && Number.isFinite(p.lat) && Number.isFinite(p.lng);

/**
 * Straight-line metres between two points (haversine on a 6,371,008.8 m
 * sphere), rounded; null when either point is missing. It is the backend's
 * own formula for an address check's distance_m (phonebook-node,
 * modules/inventory/services/addressCorrection.helpers.js haversineMetres),
 * so a distance re-measured here agrees with the server's to the metre.
 */
export function metresBetween(a, b) {
  if (!isMapPoint(a) || !isMapPoint(b)) return null;
  const toRad = (deg) => (deg * Math.PI) / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(a.lat)) * Math.cos(toRad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return Math.round(2 * 6371008.8 * Math.asin(Math.min(1, Math.sqrt(h))));
}
